var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"link":"","flat":"","width":"75"}},[_c('v-card-text',{staticStyle:{"padding-left":"10px","padding-right":"10px"},on:{"click":_vm.changeLangName}},[_vm._v(_vm._s(_vm.langName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }